import React from 'react';
import SmartDialog from "../../components/SmartDialog";
import TTLProxy from "../../common/TTLAsyncProxy";
import {TractorsEndpoints} from "../../common/ProxyEndpoints";
import {PaginatedView} from "../../components/PaginatedView";
import {Alert} from "reactstrap";
import Utils from "../../common/Utils";

const FilterView = ({ onFilterChange , filters }) => {

    return <div>

        <div className="clearfix">

            <div className="pull-left">

            </div>

            <div className="pull-right">

            </div>

        </div>

    </div>
};

class TractorRequestsView  extends React.Component {

    constructor(props){
        super(props);
        this.state = TractorRequestsView.getInitialState({});
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState(state){

        return {
            isBusy: false,
            loadError: null,
            tractor: null,
            requests: null,
            filters: {
                search: '',
                status: null,
                service: null,
                startTimeRange: null,
                endTimeRange: null,
                timeFrame: null
            },
            ...state,
        };

    }

    async loadRequests(filters){

        const { tractor } = this.state;

        try {

            this.setState({ isBusy: false });

            const res = await this.proxy.processRequest(TractorsEndpoints.getAssignedRequests(tractor.id));
            const payload = res.getPayload();

            this.setState({
                requests: payload,
                loadError: null
            });


        }
        catch (e) {

            //
            this.setState({
                loadError: Utils.getResponseError(e)
            });

        }
        finally {

            this.setState({
                isBusy: false
            });

        }
    }

    componentDidMount() {

        this.loadRequests(this.state.filters).then(() => {

            //  data loaded successfully

        });
    }

    show(tractor){

        this.setState(TractorRequestsView.getInitialState({ tractor }),() => {
            this._dlg.show()
        });

    }

    render(){

        const { filters , loadError , requests , tractor } = this.state;

        return <SmartDialog ref={r => this._dlg = r} title={`Tractor Requests ${ tractor ? Utils.formatTractorName(tractor) : ''}`.trim()} large>

            <FilterView filters={filters} onFilterChange={(filters) => {

                this.setState({
                    filters
                });

            }}/>

            <hr/>

            <PaginatedView data={requests}
                           height={350}
                           rowHeight={160}
                           noRowsHeight={350}
                           renderItem={item => {

                           }}
                           emptyMessage="No requests available yet!"/>

            {loadError && <Alert color="danger">
                <i className="fa fa-exclamation-triangle"/> {loadError}
            </Alert>}



        </SmartDialog>

    }

}

export default TractorRequestsView;


// WEBPACK FOOTER //
// ./src/views/Tractors/TractorRequestsView.js